export const siteMetadata = {
  title: "Free Marriage Biodata Maker | Create Biodata Online | Biodata360",
  description: "Create professional marriage biodata online for free. Choose from 50+ templates, download PDF instantly. Perfect for Indian matrimonial profiles. No registration required!",
  author: "Biodata360",
  email: "support@biodata360.in",
  keywords: "marriage biodata maker, biodata for marriage, create marriage biodata, marriage biodata format, free biodata maker, online biodata maker, marriage biodata template, biodata format for marriage, hindu marriage biodata, marriage biodata pdf, biodata creator, matrimonial profile, shaadi biodata, indian marriage biodata, marriage biodata word format, biodata format for girl, biodata format for boy, marriage biodata in marathi, marriage biodata in hindi, professional biodata maker, wedding biodata format, biodata template download, marriage cv format, online matrimonial profile",
  googleSiteVerification: "googleed255b82c8d8a08f",
  canonicalUrl: "https://biodata360.in/",
  siteUrl: "https://biodata360.in",
  favicon: "/Media/Website Images/Main Biodata360 Fevicon.png",
  image: "https://biodata360.in/Media/Website Images/Biodata360 Share.png",
  twitterUsername: "@Biodata360"
};

export const openGraphTags = {
  title: "Free Marriage Biodata Maker | Online Biodata Format PDF/Word",
  description: "Create your biodata for marriage for girls and boys with our templates. Download in PDF or Word format instantly.",
  type: "website",
  url: "https://biodata360.in/",
  image: "https://biodata360.in/Media/Website Images/Biodata360 Share.png",
  siteName: "Biodata360",
  locale: "en_US"
};

export const twitterTags = {
  card: "summary_large_image",
  site: "@biodata360",
  title: "Free Marriage Biodata Maker | Online Biodata Format PDF/Word",
  description: "Create your biodata for marriage for girls and boys with our templates. Download in PDF or Word format instantly.",
  image: "https://biodata360.in/Media/Website Images/Biodata360 Share.png"
};

export const googleFontsUrl = "https://fonts.googleapis.com/css2?family=Lato:wght@400;700;900&family=Roboto:wght@400;500;700&display=swap";

export const analyticsConfig = {
  googleAnalyticsId: "G-B70Q4RM88C",
  clarityId: "s7xzqv9hym"
};

// Additional SEO configurations
export const seoConfig = {
  // Default page metadata that can be overridden by specific pages
  defaultPageMetadata: {
    robots: "index, follow",
    viewport: "width=device-width, initial-scale=1.0",
    themeColor: "#ffffff",
    rating: "general",
    revisitAfter: "7 days",
    language: "English"
  },
  
  // Social media profiles for rich results
  socialProfiles: {
    facebook: "https://facebook.com/biodata360",
    twitter: "https://twitter.com/biodata360",
    instagram: "https://instagram.com/biodata360",
    linkedin: "https://linkedin.com/company/biodata360",
    youtube: "https://youtube.com/channel/biodata360"
  }
};
